var Tab;

Tab = function(self, options) {
  Selectable(self);
  if (options.api != null) {
    self.upload_api = options.api;
  }
  if (options.id != null) {
    self.upload_id = options.id;
  }
  self.assets = (function(_this) {
    return function(options, callback) {
      if (self.id !== void 0) {
        return self.api.read(self.id, options).done(callback);
      } else {
        return self.api.read(options).done(callback);
      }
    };
  })(this);
  self.asset_add = (function(_this) {
    return function(asset_id, callback) {
      return self.upload_api.create(self.upload_id, {
        asset_id: asset_id
      }).done(callback);
    };
  })(this);
  self.asset_delete = (function(_this) {
    return function(asset_id, callback) {
      return self.upload_api.destroy(self.upload_id, asset_id).done(callback);
    };
  })(this);
  return self;
};

//# sourceMappingURL=tab.js.map
